import { render } from "./NewLocationFullCard.vue?vue&type=template&id=2dcc39d6"
import script from "./NewLocationFullCard.vue?vue&type=script&lang=js"
export * from "./NewLocationFullCard.vue?vue&type=script&lang=js"

import "./NewLocationFullCard.vue?vue&type=style&index=0&id=2dcc39d6&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__